import { satisfies } from 'compare-versions';
import { memoize } from 'lodash';

/**
 * @param {string} base Base version
 * @param {string} versionString Version comparison
 * @returns {bool} Comparison result from expression `base` `versionString`
 */
export default memoize(
    (base, version) => {
        // remove alpha/beta/rc portion, or version '1.0.0-alpha' would not satisfy constraint '>=1.0.0'
        base = base.includes('-') ? base.split('-', 2)[0] : base;

        return satisfies(base, version);
    },
    (base, versionString) => `${base}${versionString}`
);
